<body>
    <div class="container container-table">
        <div class="row vertical-center-row">
            <div class="col-md-7 centered text-center">
              <div class="text-center bemvindo">
                  <img src="./assets/images/logo_NPB.png" alt="Logo Nota Premiada Bahia">
                  <h2 class="text-primary" > Parabéns, você concluiu o seu cadastro!</h2>
                  <h5>Agora é só pedir o <strong>CPF</strong> nas suas <strong>notas fiscais</strong> e concorrer a <strong>prêmios mensais</strong>.</h5>
                  <button (click) = "redirecionar()" class="btn btn-primary">Entrar <span class="fa fa-lock"></span> </button>
              </div>
            </div>
        </div>
    </div>

    <!-- Include all compiled plugins (below), or include individual files as needed -->
    <script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/js/bootstrap.min.js" integrity="sha384-Tc5IQib027qvyjSMfHjOMaLkfuWVxZxUPnCJA7l2mCWNIpG9mGCD8wGNIcPD7Txa" crossorigin="anonymous"></script>
</body>



// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-obrigado/consumidor-obrigado.component.html